// Author Liang Gang Qiang
// Date 2021-11-24 16:34:50

class MintalMesQualitySelfInspectRoast {
constructor({
        id = null,
        selfInspectId = '',
        selfInspectCode = '',
        sampleTime = '',
        inspectTime = '',
        intensityCooked = '',
        barrateIndex = '',
        antiWearIndex = '',
        qualified = '',
        size1 = '',
        size2 = '',
        size3 = '',
        size4 = '',
        size5 = '',
        size6 = '',
        size7 = '',
        size8 = '',
        inspector = '',
        status = '',
        remark = ''}
= {}) {
    this.id = id;
    this.selfInspectId = selfInspectId;
    this.selfInspectCode = selfInspectCode;
    this.sampleTime = sampleTime;
    this.inspectTime = inspectTime;
    this.intensityCooked = intensityCooked;
    this.barrateIndex = barrateIndex;
    this.antiWearIndex = antiWearIndex;
    this.qualified = qualified;
    this.size1 = size1;
    this.size2 = size2;
    this.size3 = size3;
    this.size4 = size4;
    this.size5 = size5;
    this.size6 = size6;
    this.size7 = size7;
    this.size8 = size8;
    this.inspector = inspector;
    this.status = status;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesQualitySelfInspectRoast();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sampleTime',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.sampleTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectTime',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.inspectTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'intensityCooked',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.intensityCooked',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'barrateIndex',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.barrateIndex',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'antiWearIndex',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.antiWearIndex',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualified',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.qualified',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '合格' },
                            { value: '2', text: '一级品' },
                            { value: '3', text: '二级品' },
                            { value: '4', text: '不合格' }
            ]
        }
        },
        {
        key: 'size1',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.size1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'size2',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.size2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'size3',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.size3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'size4',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.size4',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'size5',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.size5',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'size6',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.size6',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'size7',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.size7',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'size8',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.size8',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspector',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.inspector',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    selfInspectIdFilter : '',
    selfInspectCodeFilter : '',
    sampleTimeRteFilter : '',
    sampleTimeLteFilter : '',
    inspectTimeRteFilter : '',
    inspectTimeLteFilter : '',
    intensityCookedFilter : '',
    barrateIndexFilter : '',
    antiWearIndexFilter : '',
    qualifiedFilter : '',
    size1Filter : '',
    size2Filter : '',
    size3Filter : '',
    size4Filter : '',
    size5Filter : '',
    size6Filter : '',
    size7Filter : '',
    size8Filter : '',
    inspectorFilter : '',
    statusFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'selfInspectCodeFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.selfInspectCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualitySelfInspect'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"selfInspectId": "id"}'
                }
        },
        {
        key: 'sampleTimeRteFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.sampleTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sampleTimeLteFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.sampleTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'inspectTimeRteFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.inspectTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'inspectTimeLteFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.inspectTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'intensityCookedFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.intensityCooked',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'barrateIndexFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.barrateIndex',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'antiWearIndexFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.antiWearIndex',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qualifiedFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.qualified',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '合格' },
                { value: '2', text: '一级品' },
                { value: '3', text: '二级品' },
                { value: '4', text: '不合格' }
            ]
        }
        },
        {
        key: 'size1Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.size1',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'size2Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.size2',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'size3Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.size3',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'size4Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.size4',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'size5Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.size5',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'size6Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.size6',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'size7Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.size7',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'size8Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.size8',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'inspectorFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.filter.inspector',
        disabled: false,
        form: {
        type: 'input'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'selfInspectCode',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.entity.selfInspectCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualitySelfInspect'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"selfInspectId": "id"}'
                }
        },
        {
        key: 'sampleTime',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.entity.sampleTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'inspectTime',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.entity.inspectTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'intensityCooked',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.entity.intensityCooked',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'barrateIndex',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.entity.barrateIndex',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'antiWearIndex',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.entity.antiWearIndex',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'size1',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.entity.size1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'size2',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.entity.size2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'size3',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.entity.size3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'size4',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.entity.size4',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'size5',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.entity.size5',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'size6',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.entity.size6',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'size7',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.entity.size7',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'size8',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.entity.size8',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'inspector',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.entity.inspector',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectRoast.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesQualitySelfInspectRoast, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
